<template>
  <svg
    width="21"
    height="28"
    viewBox="0 0 21 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="19.8627"
      height="27"
      rx="9.93137"
      stroke=""
    />
    <line
      x1="10.833"
      y1="6.44116"
      x2="10.833"
      y2="13.3235"
      stroke=""
      stroke-width="3"
      stroke-linecap="round"
    />
  </svg>
</template>
